import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "./Confirmation.css";
import { TextField } from "@mui/material";

const getStyle = (width) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "auto", sm: width },
  maxWidth: "calc(100% - 32px)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
});

function Confirmation(props) {
  const {
    showReason,
    customDescriptionStyle,
    open,
    handleClose,
    title,
    description,
    cancelButtonNotRequired,
    onCancel,
    cancelButtonLabel,
    confirmButtonNotRequired,
    onConfirm,
    confirmButtonLabel,
    width,
  } = props;

  const [reason, setReason] = useState("");
  const trimmedReason = reason.trim();
  const hasCancelButton = cancelButtonNotRequired === false;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={getStyle(width)}>
        <Typography id="modal-modal-title" sx={{ mb: 2 }}>
          {title} {showReason && <span className="asterisk">*</span>}
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{ mb: 2, mt: 2, ...customDescriptionStyle }}
        >
          {description}
        </Typography>

        {showReason && (
          /*istanbul ignore next */
          <div className="reason-div mt-3">
            <TextField
              multiline
              value={reason}
              rows={3}
              onChange={(e) => {
                /*istanbul ignore next */
                setReason(e.target.value);
              }}
              data-testid="reason_textbox"
              style={{ width: "100%", padding: 1 }}
            />
          </div>
        )}

        <div className="action-btn-div mt-3">
          {!cancelButtonNotRequired && (
            <Button
              className="action-button"
              variant="outlined"
              onClick={(e) => {
                setReason("");
                onCancel(e);
              }}
              data-testid="cancel-action"
            >
              {cancelButtonLabel}
            </Button>
          )}
          {!confirmButtonNotRequired && (
            <Button
              className={
                hasCancelButton ? "action-button ml-4" : "action-button"
              }
              variant="contained"
              onClick={(e) => {
                setReason("");
                onConfirm(e, trimmedReason);
              }}
              data-testid="confirm-action"
              disabled={showReason && trimmedReason === ""}
            >
              {confirmButtonLabel}
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
}

// ✅ Add PropTypes validation
Confirmation.propTypes = {
  showReason: PropTypes.bool,
  customDescriptionStyle: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  cancelButtonNotRequired: PropTypes.bool,
  onCancel: PropTypes.func,
  cancelButtonLabel: PropTypes.string,
  confirmButtonNotRequired: PropTypes.bool,
  onConfirm: PropTypes.func,
  confirmButtonLabel: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

// ✅ Default props for optional values
Confirmation.defaultProps = {
  showReason: false,
  customDescriptionStyle: {},
  description: "",
  cancelButtonNotRequired: false,
  confirmButtonNotRequired: false,
  cancelButtonLabel: "Cancel",
  confirmButtonLabel: "Confirm",
  width: 400,
};

export default Confirmation;
